import { render, staticRenderFns } from "./GermplasmDetail.vue?vue&type=template&id=e7b040d4&scoped=true"
import script from "./GermplasmDetail.vue?vue&type=script&lang=js"
export * from "./GermplasmDetail.vue?vue&type=script&lang=js"
import style0 from "./GermplasmDetail.vue?vue&type=style&index=0&id=e7b040d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b040d4",
  null
  
)

export default component.exports